/*
 * @Description: 
 * @Version: 
 * @Autor: LiChuang
 * @Date: 2024-08-05 09:06:03
 * @LastEditors: 
 * @LastEditTime: 2024-08-09 20:32:00
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('focus', {
    mounted (el) {
      el.focus()
    },
    getSSRProps (binding, vnode) {
      // you can provide SSR-specific props here
      return {}
    }
  })
})